export default "__VITE_ASSET__CBi9iMNa__"